import { render } from "./index.vue?vue&type=template&id=08d5dce0&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=08d5dce0&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d5dce0"]])

export default __exports__